import React from 'react';
import * as HELPERS from '../_helpers/url.helpers';
import * as CONSTANTS from '../_constants';
import {  } from "react-bootstrap";
import ReactLoading from 'react-loading';
import { Element, animateScroll as scroll } from 'react-scroll'

class Summary extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            fetching: true,
            displayMenu : false,
            [CONSTANTS.SECTIONS.SUMMARY] : null
        }
    }

    scrollTo() {
		scroll.scrollTo(500);
	}

    componentDidMount() {
        let params = this.props.match.params;
        this.fetchSummaryDetails(params.summary_id);
    }

    /**
	 * Fetches the details for a given summary's id
	 * 
	 * @param {string} id 
	 */
	fetchSummaryDetails(id) {
        
		this.setState({ fetching: true });
		//Do the fetch to get the details
		let type = CONSTANTS.ENDPOINTS.GET_SUMMARY_BY_ID;
		
		let url = HELPERS.generateAPIUrlTypeSectionAndTitle(type);
		url = `${url}&id=${id}`;

        fetch(url)
            .then(response => response.json())
            .then(this.renderSummaryDetails.bind(this))
    }

    toggleMenu() {
        if(this.state.displayMenu) {
            this.setState({ displayMenu : false });
        } else {
            this.setState({ displayMenu : true });
        }
    }
    
    /**
	 * 
	 */
	renderSummaryDetails(data) {
        this.scrollTo();
        this.setState({ [CONSTANTS.SECTIONS.SUMMARY]: data.output, fetching: false })
	}

    render() {
        if(this.state.fetching) {
           return <span className="loading"><ReactLoading type="spinningBubbles" color="#0089BB"/></span>
        }
        if(!this.state[CONSTANTS.SECTIONS.SUMMARY]) return null;
        
        let displayClass = this.state.displayMenu ? "row-offcanvas-right active col-md-4 col-sm-12 col-xs-12" : "sidebar-offcanvas col-md-4 col-sm-12 col-xs-12";

        return (
            <Element name="summaries-details">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-lg-12" id="summary-details-title-wrapper">
                            <h2>{this.state[CONSTANTS.SECTIONS.SUMMARY].info.title}</h2>
                        </div>
                        <div className={`${displayClass}`} id="sidebar">
                            <ul className="list-group">
                                {this.state[CONSTANTS.SECTIONS.SUMMARY].nav.map((x, i)=>{
                                        return (
                                            <li key={i} className="list-group-item"><a href={x.id}>{x.text}</a></li>
                                        )
                                    })}
                            </ul>
                        </div>
                        {/*<button onClick={this.toggleMenu.bind(this)} type="button" className="pull-left btn btn-default visible-xs" data-toggle="offcanvas" aria-expanded="false" aria-controls="navbar">
                            <i className="fa fa-navicon"></i>
                        </button>*/}
                        <div className="col-md-8 col-sm-12 col-xs-12 pull-right">
                            <div onClick={()=>{ this.setState({ displayMenu: false })}} dangerouslySetInnerHTML={{__html:this.state[CONSTANTS.SECTIONS.SUMMARY].html}} id="summary-details" />
                        </div>
                    </div>
                </div>
            </Element>
        )
    }
}

export default Summary;